var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"wrapper wrapper-content animated fadeInRight"},[_vm._v("\n\n    Storage page\n    \n    "),_c('FileUpload')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }